module.exports = __webpack_public_path__ + "img/Astrall.26fdb851.jpg";